import { TransformMapperActions } from './TransformMapper.actions';
import { FileDefinitionActions } from './FileDefinition.actions';

export const config = {
  namespaced: true,
  state: () => ({
    sources: [],
    dests: [],
    availableTables: [],
    tableColumns: {},
  }),
  mutations: {
    setAvailableTables(state, tables) {
      state.availableTables = tables;
    },
    setTableColumns(state, { tableName, columns }) {
      state.tableColumns = { ...state.tableColumns, [tableName]: columns };
    },
  },
  actions: {
    ...TransformMapperActions,
    ...FileDefinitionActions,
  },
};

export default {
  config,
};
